import { render } from "./TeamMember.vue?vue&type=template&id=0d4fe69e"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"

import "./TeamMember.vue?vue&type=style&index=0&id=0d4fe69e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__